var map = {
	"./baac.svg": 972,
	"./bay.svg": 973,
	"./bbl.svg": 974,
	"./bnp.svg": 975,
	"./boa.svg": 976,
	"./cacib.svg": 977,
	"./cimb.svg": 978,
	"./citi.svg": 979,
	"./db.svg": 980,
	"./ghb.svg": 981,
	"./gsb.svg": 982,
	"./hsbc.svg": 983,
	"./ibank.svg": 984,
	"./icbc.svg": 985,
	"./jpm.svg": 986,
	"./kbank.svg": 340,
	"./kk.svg": 987,
	"./ktb.svg": 988,
	"./lhb.svg": 989,
	"./mb.svg": 990,
	"./mega.svg": 991,
	"./mufg.svg": 992,
	"./rbs.svg": 993,
	"./sc.svg": 994,
	"./scb.svg": 995,
	"./smbc.svg": 996,
	"./tbank.svg": 997,
	"./tcrb.svg": 998,
	"./tisco.svg": 999,
	"./tmb.svg": 1000,
	"./ttb.svg": 1001,
	"./uob.svg": 341
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaibank ^\.\/.*\.svg$
// module id = 105
// module chunks = 1